import { axiosInstancePrivateServicesFluxiUrl } from "@/services/instance";

export interface ExperimentFlag {
  enabled: string | boolean;
  agent?: string;
}

export interface UserExperimentsResponse {
  experiments: Record<string, ExperimentFlag>;
}

export const userExperimentsService = {
  async getExperiments(): Promise<UserExperimentsResponse> {
    const response = await axiosInstancePrivateServicesFluxiUrl.get(
      `/api/ms/ecommerce-service/user/experiments`
    );
    return response.data as UserExperimentsResponse;
  },
};
